import React, { useEffect, useRef } from "react";

import styles from "./BtnDrawerSelect.module.scss";
import { IconType } from "../../../assets/JWayIcons";

export interface BtnDrawerSelectProps {
  label?: string;
  iconType?: IconType;
  children?: React.ReactNode;
  contentRender?: (params: { closeModal: () => void }) => JSX.Element;
  btnRender?: (params: { onClick: () => void }) => JSX.Element;
  marginTopModal?: string | number;
  width?: string | number;
  minHeightModal?: string | number;
  minWidthModal?: string | number;
}

export default function BtnDrawerSelect({
  label,
  iconType,
  contentRender,
  children,
  btnRender,
  marginTopModal = 30,
  width,
  minHeightModal = 200,
  minWidthModal = 200,
  
}: BtnDrawerSelectProps) {
  const [open, setOpen] = React.useState(false);
  const onClick = () => {
    setOpen(!open);
  };

    const modalRef = useRef<HTMLDivElement>(null);
  
    const handleClickOutside = (event: MouseEvent) => {
      if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
        setOpen(false);
      }
    };


      useEffect(() => {
        if (open) {
          document.addEventListener("mousedown", handleClickOutside);
        } 
        return () => {
          document.removeEventListener("mousedown", handleClickOutside);
        };
      }, [open]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div className={styles["btn-drawer-select-container"]} >
      {btnRender ? (
        btnRender({ onClick })
      ) : (
        <button className={[styles["btn-drawer-select"], styles["btn-drawer-select-container__btn-drawer-select"]].join(" ")} onClick={onClick}>
          {iconType && (
            <div className={styles["btn-drawer-select__icon"]}>{iconType}</div>
          )}
          <div className={styles["btn-drawer-select__label"]}>{label}</div>
        </button>
      )}
      {open && (
        <div  style={{marginTop: marginTopModal, minHeight: minHeightModal,width: width, minWidth:  minWidthModal}} ref={modalRef} className={[styles["modal"]].join(" ")}>
          <div className={[styles["modal__content"]].join(" ")}>
            {contentRender && contentRender({ closeModal: () => setOpen(false) })}{" "}
            {children && children}{" "}
          </div>
        </div>
      )}
    </div>
  );
}
